import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../api';

// ==================== Initial State ====================
const initialState = {
    stats: null,           // Counts for stat cards
    genderStats: null,     // Donut chart data
    programStats: null,    // Horizontal bar chart data
    monthlyTrends: null,   // Bar chart data (Admissions vs Inquiries)
    activities: [],        // Recent activity timeline
    isLoading: false,
    error: null,
};

// ==================== Async Thunks ====================

// Fetch all dashboard statistics and chart data
export const fetchDashboardStats = createAsyncThunk(
    'dashboard/fetchDashboardStats',
    async (_, { rejectWithValue }) => {
        try {
            // Backend route: /dashboard/stats
            const response = await api.get('/dashboard/stats');
            return response.data.data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || 'Failed to fetch dashboard data'
            );
        }
    }
);

// ==================== Slice ====================
const dashboardSlice = createSlice({
    name: 'dashboard',
    initialState,
    reducers: {
        clearDashboardError: (state) => {
            state.error = null;
        },
        resetDashboardState: (state) => {
            return initialState;
        },
    },
    extraReducers: (builder) => {
        builder
            // FETCH DASHBOARD STATS
            .addCase(fetchDashboardStats.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(fetchDashboardStats.fulfilled, (state, action) => {
                state.isLoading = false;
                // Data mapping as per the Laravel Controller response
                state.stats = action.payload.stats;
                state.genderStats = action.payload.genderStats;
                state.programStats = action.payload.programStats;
                state.monthlyTrends = action.payload.monthlyTrends;
                state.activities = action.payload.activities;
            })
            .addCase(fetchDashboardStats.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            });
    },
});

export const { clearDashboardError, resetDashboardState } = dashboardSlice.actions;

export default dashboardSlice.reducer;